import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-launches-ocean-container-search',
  template: require('./linescape-launches-ocean-container-search.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-launches-ocean-container-search.component.scss')]
})
export class LinescapeLaunchesOceanContainerSearchComponent extends BlogPage {
  title = "Linescape launches Ocean Container Schedule Search Engine - Linescape";
  description = "Innovative, Powerful Tool Reveals Optimum Container Shipping Schedules Using Advanced Features and Industry’s Broadest Database.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-launches-ocean-container-search/linescape-launches-ocean-container-search.component.ts